import { ChevronLeft, ChevronRight } from "lucide-react";

interface DataTablePaginationProps {
  page: number;
  totalPages: number;
  total?: number;
  pageSize?: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function DataTablePagination({
  page,
  totalPages,
  total = 0,
  pageSize = 10,
  onPageChange,
  className = "",
}: DataTablePaginationProps) {
  const pages = Math.max(totalPages, 1);
  if (total === 0) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div
      className={`flex flex-col sm:flex-row items-center justify-between gap-3 ${className}`}
    >
      <p className="text-[10px] text-[var(--text-muted)]">
        Showing {start}–{end} of {total} · Page {page} of {pages}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="btn-gold-outline text-xs py-2 px-3 disabled:opacity-40 flex items-center gap-1 min-h-[36px]"
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </button>
        <button
          type="button"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          className="btn-gold-outline text-xs py-2 px-3 disabled:opacity-40 flex items-center gap-1 min-h-[36px]"
        >
          Next <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
